/** Candy manifest — wraps existing CANDY_ASSETS into the per-game GameSceneConfig shape. */
import { CANDY_ASSETS, CANDY_AUDIO } from '@/game/assets/assetManifest'
import { AssetKeys } from '@/config/AssetKeys'
import type { GameSceneConfig } from '../types'

export const CANDY_SCENE_CONFIG: GameSceneConfig = {
  id: 'candy',
  images: CANDY_ASSETS.map((a) => ({ key: a.key, path: a.path })),
  audio: CANDY_AUDIO.map((a) => ({ key: a.key, path: a.path })),
  bgMainKey: AssetKeys.bg.main,
  bgLoadingKey: AssetKeys.bg.loading,
  grid: { cols: 6, rows: 5, cellWidth: 156, cellHeight: 156 },
  symbolToAsset: {
    CHERRY: AssetKeys.symbol.cherry,
    LEMON: AssetKeys.symbol.lemon,
    WATERMELON: AssetKeys.symbol.watermelon,
    STRAWBERRY: AssetKeys.symbol.strawberry,
    BLUEBERRY: AssetKeys.symbol.blueberry,
    RAINBOW: AssetKeys.symbol.rainbow,
    CROWN: AssetKeys.symbol.heart_gummy,
    GOLDEN7: AssetKeys.symbol.star_candy,
    WILD: AssetKeys.symbol.chocolate_square,
    SCATTER: AssetKeys.symbol.lollipop_scatter,
    MULTIPLIER: AssetKeys.symbol.multiplier_orb,
  },
  bgmMainKey: AssetKeys.audio.bgm_main,
  sfxSpinTapKey: AssetKeys.audio.sfx_spin_tap,
  sfxReelStopKey: AssetKeys.audio.sfx_reel_stop,
  sfxSmallWinKey: AssetKeys.audio.sfx_small_win,
  sfxBigWinCountKey: AssetKeys.audio.sfx_big_win_count,
}
